<template lang="pug">
.waiter-family-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：送信手段
    template(#cell(senderType)="row") 
      span {{ getSenderType(row.item.senderType) }}
    // セル：登録情報
    template(#cell(operation)="row")
      .control-buttons(v-if="row.item.senderType == 0")
        button.btn.edit-btn(@click="onEdit(row.item)" type="button") 修正
        button.btn.delete-btn(@click="onLineDelete(row.item)" type="button") 削除
      .control-buttons(v-if="row.item.senderType == 1")
        button.btn.edit-btn(@click="onEdit(row.item)" type="button") 修正
        button.btn.delete-btn(@click="onMailDelete(row.item)" type="button") 削除
    // セル：登録確認
    template(#cell(sendMessage)="row")
      button.btn.testmail-btn(v-if="row.item.senderType == 1" @click="onSendMessage(row.item)" type="button") 確認送信
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SenderType } from "@/commons/models/Resident";

/**
 * 家族テーブルコンポーネント
 */
@Component({})
export default class WaiterFamilyTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<WaiterFamilyTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<WaiterFamilyTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<WaiterFamilyTableItem> {
    return this.value;
  }

  /**
   * ### 送信種別を返す
   */
  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.LINE) {
      return "LINE";
    } else if (senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(family: WaiterFamilyTableItem): void {
    this.$emit("onEdit", family);
    return;
  }

  /**
   * ### LINEユーザー削除ボタン押下イベント
   */
  public onLineDelete(family: WaiterFamilyTableItem): void {
    this.$emit("onLineDelete", family);
    return;
  }

  /**
   * ### MAILユーザー削除ボタン押下イベント
   */
  public onMailDelete(family: WaiterFamilyTableItem): void {
    this.$emit("onMailDelete", family);
    return;
  }

  /**
   * ### 確認送信ボタン押下イベント
   */
  public onSendMessage(family: WaiterFamilyTableItem): void {
    this.$emit("onSendMessage", family);
    return;
  }
}

/** テーブルの列名の情報 */
export interface WaiterFamilyTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface WaiterFamilyTableItem {
  id: number;
  residentsSortKey: string;
  residentName: string;
  familyId: number;
  familyName: string;
  familyRelation: string;
  familyPosition: string;
  familyMailaddress: string;
  familyReplyFunction: boolean;
  familyPictureFunction: boolean;
  familyTel: string;
  senderType: SenderType;
  updated: number;
}
</script>

<style lang="scss" scoped>
.waiter-family-table-component {
  .edit-btn,
  .delete-btn {
    width: 64px;
  }

  .edit-btn {
    margin-right: 12px;
  }

  .testmail-btn {
    width: 100px;
  }

  .position-name {
    margin-right: 4px;
  }
}
</style>
